import React, { Component, useState } from "react";
import "leaflet/dist/leaflet.css";

export default function PerformanceTable() {
  return (
    <table className="KPIs-table">
      <tr>
        <th>Strategic Imperative</th>
        <th>KPI</th>
        <th>Unit</th>
        <th>Weight (%)</th>
        <th>
          <div>Target</div>
          <div>YTD</div>
        </th>
        <th>
          <div>Actual</div>
          <div>YTD</div>
        </th>
        <th>%Achieved</th>
        <th>Score</th>
        <th>
          <div>Actual</div>
          <div>Jan</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Feb</div>
        </th>
        <th>
          <div>Mar</div>
          <div>Jan</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Apr</div>
        </th>
        <th>
          <div>Actual</div>
          <div>May</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Jun</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Jul</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Aug</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Sep</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Oct</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Nov</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Dec</div>
        </th>
      </tr>
      <tr className="table-collapse">
        <td style={{ border: "none", background: "yellow" }}>Performance</td>
        <td style={{ border: "none", background: "yellow" }}></td>
        <td style={{ border: "none", background: "yellow" }}></td>
        <td style={{ border: "none", background: "yellow" }}></td>
        <td style={{ border: "none", background: "yellow" }}></td>
        <td style={{ border: "none", background: "yellow" }}></td>
        <td style={{ border: "none", background: "yellow" }}></td>
        <td style={{ border: "none", background: "yellow" }}></td>
        <td style={{ border: "none", background: "yellow" }}></td>
        <td style={{ border: "none", background: "yellow" }}></td>
        <td style={{ border: "none", background: "yellow" }}></td>
        <td style={{ border: "none", background: "yellow" }}></td>
        <td style={{ border: "none", background: "yellow" }}></td>
        <td style={{ border: "none", background: "yellow" }}></td>
        <td style={{ border: "none", background: "yellow" }}></td>
        <td style={{ border: "none", background: "yellow" }}></td>
        <td style={{ border: "none", background: "yellow" }}></td>
        <td style={{ border: "none", background: "yellow" }}></td>
        <td style={{ border: "none", background: "yellow" }}></td>
        <td style={{ border: "none", background: "yellow" }}></td>
      </tr>
      <tr style={{ textAlign: "center" }}>
        <td></td>
        <td>ยอดขาย</td>
        <td>ล้านบาท</td>
        <td>16.0%</td>
        <td>30,100</td>
        <td>31,519</td>
        <td>105%</td>
        <td>4</td>
        <td>2,236</td>
        <td>2,034</td>
        <td>2,373</td>
        <td>2,558</td>
        <td>2,550</td>
        <td>2,629</td>
        <td>2,725</td>
        <td>2,882</td>
        <td>2,725</td>
        <td>2,852</td>
        <td>2,917</td>
        <td>3,038</td>
      </tr>
      <tr style={{ textAlign: "center" }}>
        <td></td>
        <td>กำไร</td>
        <td>ล้านบาท</td>
        <td>16.0%</td>
        <td>2,600</td>
        <td>2,235</td>
        <td>86%</td>
        <td>3</td>
        <td>181</td>
        <td>131</td>
        <td>149</td>
        <td>192</td>
        <td>198</td>
        <td>148</td>
        <td>115</td>
        <td>173</td>
        <td>218</td>
        <td>231</td>
        <td>261</td>
        <td>236</td>
      </tr>
      <tr style={{ textAlign: "center" }}>
        <td></td>
        <td>%NP</td>
        <td>%</td>
        <td>16.0%</td>
        <td>30,100</td>
        <td>31,519</td>
        <td>105%</td>
        <td>4</td>
        <td>2,236</td>
        <td>2,034</td>
        <td>2,373</td>
        <td>2,558</td>
        <td>2,550</td>
        <td>2,629</td>
        <td>2,725</td>
        <td>2,882</td>
        <td>2,725</td>
        <td>2,852</td>
        <td>2,917</td>
        <td>3,038</td>
      </tr>
      <tr style={{ textAlign: "center" }}>
        <td></td>
        <td>%Utilization - โรงแปรรูป</td>
        <td>%</td>
        <td>16.0%</td>
        <td>30,100</td>
        <td>31,519</td>
        <td>105%</td>
        <td>4</td>
        <td>2,236</td>
        <td>2,034</td>
        <td>2,373</td>
        <td>2,558</td>
        <td>2,550</td>
        <td>2,629</td>
        <td>2,725</td>
        <td>2,882</td>
        <td>2,725</td>
        <td>2,852</td>
        <td>2,917</td>
        <td>3,038</td>
      </tr>
    </table>
  );
}
